import { useEffect, useState } from "react";

import { getRequiredConsents } from "src/api/client";
import type { ConsentType } from "src/api/types";

export function useRequiredConsents(
  clientId: string,
  streamToken: string,
  enabled: boolean,
): [ConsentType[] | null, (types: ConsentType[]) => void, string | undefined] {
  const [consentTypes, setConsentTypes] = useState<ConsentType[] | null>(null);
  const [state, setState] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!enabled || !clientId || !streamToken) return;
    let cancelled = false;
    getRequiredConsents(clientId, streamToken)
      .then((res) => {
        if (cancelled) return;
        setConsentTypes(res.consentTypes);
        setState(res.state);
      })
      .catch(() => {
        // stay null: the prompt is hidden and the screen is as before
      });
    return () => {
      cancelled = true;
    };
  }, [enabled, clientId, streamToken]);

  return [consentTypes, setConsentTypes, state];
}
